export default __webpack_public_path__ + "static/media/chat-icon.d0ad1b4f.svg";